import {Component, OnInit, OnDestroy} from '@angular/core';
import {NotifierService} from 'angular-notifier';
import {RestApiService} from '../rest-api.service';
import {Router} from '@angular/router';
import {Formatters} from 'angular-slickgrid';
import {MessageService} from '../message.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-vendor-user',
  templateUrl: './vendor-user.component.html',
  styleUrls: ['./vendor-user.component.css']
})
export class VendorUserComponent implements OnInit, OnDestroy {

  vendorSelected: number;
  roleSelected: number;
  userSelected: number;
  show: boolean;
  dataset: any[];
  totalData: number;
  respObject: any;
  vendors = [];
  users = [];
  role = [];
  vendorName: string;
  userName: string;
  roleName: string;


  displayData: any;

  add = false;
  del = false;
  edit = false;
  view = false;

  isError = false;
  errorMessage: string;

  private notifier: NotifierService;
  private clientId: number;
  nextOffset: number;
  previousOffset: number;
  pageSize: number;
  paginationType: string;
  page_no: number;
  totalPage: number;
  private userAuth: Subscription;
  private baseFlag: any;
  offset: number;
  dataLoaded:boolean;
  // userRoleMap: UserRoleMapping [] = [];

  constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
              private modalService: NgbModal, notifier: NotifierService) {
    this.notifier = notifier;
    this.messageService.getCellChangeData().subscribe(item => {
      switch (item.type) {
        case 'change':
          // console.log('changed');
          if (!this.messageService.edit) {
            this.notifier.notify('error', 'You do not have edit permission');
          } else {

          }
          break;
        case 'delete':
          // console.log('deleted');
          if (!this.messageService.del) {
            this.notifier.notify('error', 'You do not have delete permission');
          } else {
            if (confirm('Are you sure?')) {
              this._rest.deleteClientVendorUserMapping({id: item.id, user_id: this.messageService.getUserId()}).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                  // this.totalData = this.totalData - 1;
                  // this.messageService.setTotalData(this.totalData);
                  this.messageService.sendAfterDelete(item.id);
                } else {
                  this.notifier.notify('error', this.respObject.errorMessage);
                }
              }, (err) => {
                this.notifier.notify('error', this.respObject.errorMessage);
              });
            }
          }
          break;
      }
    });

    // this.messageService.getUserAuth().subscribe(details => {
    //   console.log(JSON.stringify(details));
    //   if (details.length > 0) {
    //     this.add = details[0].addFlag;
    //     this.del = details[0].deleteFlag;
    //     this.view = details[0].viewFlag;
    //     this.edit = details[0].editFlag;
    //   }
    // });
  }


  ngOnInit() {
    this.dataLoaded=false;
    this.nextOffset = 0;
    this.previousOffset = 0;
    this.pageSize = this.messageService.pageSize;
    this.page_no = 0;
    this.totalPage = 0;
    this.paginationType = 'next';
    this.displayData = {
      pageName: 'Maintain Vendor  Mapping With User',
      openModalButton: 'Map Vendor User Map',
      breadcrumb: 'VendorUserMap',
      folderName: 'All Client Vendor User Map',
      tabName: 'Vendor User Map'
    };
    const columnDefinitions = [
      {
        id: 'delete',
        field: 'id',
        excludeFromHeaderMenu: true,
        formatter: Formatters.deleteIcon,
        minWidth: 30,
        maxWidth: 30,
      },
      // {id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true},
      {
        id: 'user_name', name: 'User ', field: 'user_name', sortable: true, filterable: true
      },
      {
        id: 'ROLE_NAME', name: 'Role ', field: 'role_name', sortable: true, filterable: true
      },
      {
        id: 'vendor', name: 'Vendor ', field: 'vendor_name', sortable: true, filterable: true
      }
    ];
    this.messageService.setColumnDefinitions(columnDefinitions);
    if (this.messageService.clientId) {
      this.clientId = this.messageService.clientId;
      this.baseFlag = this.messageService.baseFlag;
      this.onPageLoad();
    } else {
      this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
        this.view = auth[0].viewFlag;
        this.add = auth[0].addFlag;
        this.edit = auth[0].editFlag;
        this.del = auth[0].deleteFlag;
        this.clientId = auth[0].clientId;
        this.baseFlag = auth[0].baseFlag;
        this.onPageLoad();
      });
    }
  }

  onPageLoad() {
        this._rest.getRoleClientWise(this.clientId).subscribe((res1) => {
          this.respObject = res1;
          if (this.respObject.success) {
            this.isError = false;
            this.respObject.roles.unshift({id: 0, name: 'Select Role'});
            this.role = this.respObject.roles;
            this.roleSelected = 0;
          } else {
            this.isError = true;
            this.errorMessage = this.respObject.errorMessage;
          }
        }, (err) => {
          this.isError = true;
          this.errorMessage = this.messageService.SERVER_ERROR;
        });
        this._rest.getVendorMst(this.clientId).subscribe((res1) => {
          this.respObject = res1;
          if (this.respObject.success) {
            this.isError = false;
            this.respObject.details.unshift({id: 0, name: 'Select Vendor'});
            this.vendors = this.respObject.details;
            this.vendorSelected = 0;
          } else {
            this.isError = true;
            this.errorMessage = this.respObject.errorMessage;
          }
        }, (err) => {
          this.isError = true;
          this.errorMessage = this.messageService.SERVER_ERROR;
        });
      this.getTableData();
  }

  changeRouting(path: string) {
    this.messageService.changeRouting(path);
  }

  onVendorChange(selectedIndex) {
    this.vendorName = this.vendors[selectedIndex].name;
  }

  openModal(content) {
    if (!this.messageService.add) {
      this.notifier.notify('error', 'You do not have add permission');
    } else {
      this.isError = false;
      this.vendorSelected = 0;
      this.roleSelected = 0;
      this.userSelected = 0;
      this.modalService.open(content, {size: 'sm'}).result.then((result) => {
      }, (reason) => {
      });
    }
  }

  save() {
    const data = {
      clientId: this.clientId,
      vendorId: this.vendorSelected,
        refer_user_id: this.userSelected,
      roleId: this.roleSelected,
      createdBy: this.messageService.getUserId()
    };
    if (!this.messageService.isBlankField(data)) {
      this._rest.insertClientVendorUserMapping(data).subscribe((res) => {
        this.respObject = res;
        if (this.respObject.success) {
          this.totalData = this.totalData + 1;
          this.messageService.setTotalData(this.totalData);
          this.isError = false;
          const id = this.respObject.id;
          this.messageService.setRow({id: id, user_name: this.userName, role_name: this.roleName, vendor_name: this.vendorName});
          if (this.totalData <= this.pageSize * this.page_no) {
              this.offset = id;
              this.nextOffset = 0;
          } else {
              this.nextOffset = this.offset;
          }
          this.vendorSelected = 0;
          this.userSelected = 0;
          this.roleSelected = 0;
        } else {
          this.isError = true;
          this.errorMessage = this.respObject.errorMessage;
        }
      }, (err) => {
        this.isError = true;
        this.errorMessage = err;
      });
    } else {
      this.isError = true;
      this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
    }
  }

  getTableData() {
    if (!this.messageService.view) {
      this.notifier.notify('error', 'You do not have view permission');
    } else {
      this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }
  }

  isEmpty(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }

  getData(paginationObj) {
    const offset = paginationObj.offset;
    const paginationType = paginationObj.paginationType;
    this.dataLoaded=false;
    this._rest.getClientVendorUserMapping(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
      this.respObject = res;
      this.executeResponse(this.respObject, offset, paginationType);
    }, (err) => {
      this.notifier.notify('error', JSON.stringify(err));
    });
  }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
          this.dataLoaded=true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

  onUserChange(selectedIndex: any) {
    this.userName = this.users[selectedIndex].name;
  }

  onRoleChange(selectedIndex: any) {
    this.roleName = this.role[selectedIndex].name;
    this._rest.getUserByRole({clientId: this.clientId, roleId: this.roleSelected}).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.isError = true;
        this.respObject.details.unshift({id: 0, name: 'Select User'});
        this.users = this.respObject.details;
        this.userSelected = 0;
      } else {
        this.isError = true;
        this.errorMessage = this.respObject.errorMessage;
      }
    }, (err) => {
      this.isError = true;
      this.errorMessage = this.messageService.SERVER_ERROR;
    });
  }

  onPageSizeChange(value: any) {
    this.page_no = 0;
    this.nextOffset = 0;
    this.pageSize = value;
    this.getData({'offset': this.nextOffset, 'paginationType': ''});
  }

  ngOnDestroy(): void {
    if (this.userAuth) {
      this.userAuth.unsubscribe();
    }
  }

}
